import {get, isArray, isEmpty, isObject, isString, mapValues, uniq} from 'lodash'
import {SubmissionError} from 'redux-form'
import {logError} from 'libs/telemetry'
import {navigateTo, redirectTo} from 'browserHistory'
import readBlob from 'readBlob'
import {getNestedErrors, getBaseErrors} from 'libs/errorHandler'
import {asyncError} from 'store/actions/asyncError'
import {notifyError} from 'store/actions/notify'

const errorHandler = (store) => (next) => (action) => {
  if (isObject(action) && asyncError.match(action)) {
    const err = action.payload
    if (err instanceof SubmissionError) {
      throw err
    }
    if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'sandbox' && console.error) {
      console.error(err)
    }
    if (err.response) {
      if (err.response.data instanceof Blob && err.response.data.type == 'application/json') {
        readBlob(err.response.data)
          .json()
          .then((data) => {
            err.response.data = data
            store.dispatch(asyncError(err))
          })
        return
      }
      if (get(err.response, 'data._redirect_to_employee')) {
        navigateTo('/initial_input')
        return
      }
      if (get(err.response, 'data._redirect_to_login')) {
        redirectTo('/login')
      }
      if (err.response.status == 401 && isEmpty(get(err.response, 'data._errors._base'))) {
        if (/^\/tm/.test(window.location.pathname)) {
          window.location = '/api/jbc-oauth/login?d=tm'
        } else {
          window.location = '/api/jbc-oauth/login'
        }
        return
      }
      if (err.response.status == 403 && isEmpty(get(err.response, 'data._errors._base'))) {
        store.dispatch(notifyError('操作権限がありません'))
        return
      }
      if (err.response.status !== 200) {
        const baseErrors = uniq([...getBaseErrors(err.response.data)].filter(isString))
        if (baseErrors.length > 0) {
          baseErrors.forEach((msg) => {
            store.dispatch(notifyError(msg))
          })
          return
        }
      }
      if (err.response.status == 422 && get(err.response, 'data._errors')) {
        const errors = mapValues(err.response.data._errors, (value) => (isArray(value) ? value[0] || '' : value))
        throw new SubmissionError(errors)
      }
      if (err.response.status == 422) {
        const errors = getNestedErrors(err.response.data)
        if (!isEmpty(errors)) {
          throw new SubmissionError(errors)
        }
      }
    }
    logError(err)
    store.dispatch(notifyError(err.message))
  }
  next(action)
}

export default errorHandler
